let DeviceDetector = /** @class */ (() => {
    class DeviceDetector {
        constructor(win = window, doc = win.document) {
            this.win = win;
            this.doc = doc;
        }
        activate() {
            this.win.addEventListener('load', () => {
                this.setupDeviceClass();
            });
        }
        setupDeviceClass() {
            const className = this.isMobile()
                ? 'mobile-device'
                : 'desktop-device';
            this.doc.body.classList.add(className);
        }
        isMobile() {
            const userAgent = this.win.navigator.userAgent;
            return DeviceDetector.MOBILE_USER_AGENT_RE
                .some(re => re.test(userAgent));
        }
    }
    DeviceDetector.MOBILE_USER_AGENT_RE = [
        /Android/i,
        /webOS/i,
        /iPhone/i,
        /iPad/i,
        /iPod/i,
        /BlackBerry/i,
        /Windows Phone/i
    ];
    return DeviceDetector;
})();
export { DeviceDetector };
